import React from 'react';

const ExpandTreeIcon = ({ onClick, collapsed, displayIcon = true }) => (
    <i onClick={onClick} className={`fal fa-${collapsed ? 'plus' : 'minus'}-square pointer ${displayIcon ? 'visible' : 'invisible'}`} />
);

export default ExpandTreeIcon;
